import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  emergencyContactLength: 0,
  emergencyContacts: [],
}

export default function emergencyContactReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_EMERGENCY_CONTANCT:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_EMERGENCY_CONTACT:
      return {...state, saveLoader: action.payload}
    case actions.GET_EMERGENCY_CONTANCT:
      return {...state, emergencyContacts: action.payload.emergencyContacts, emergencyContactLength: action.payload.emergencyContactLength}
    default:
      return state
  }
}